The date & time the position failed to post or update.

This field has weak ordering guarantees, so it should not be used as a pagination argument.
